import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { clinicalQuestions, timeWasters } from '../../data/content';
export function ProblemSection() {
  return <section className="bg-white py-14 sm:py-20" aria-labelledby="problem-title" data-id="element-251" data-mp="8ipjaqaaqajb">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-252" data-mp="dibxb1xy7ut6">
        <SectionHeading eyebrow="The real problem" title={<span id="problem-title" data-id="element-254" data-mp="3lgzkl9i1yfy">
              How much time do you spend every week solving a clinical decision that should take
              only a few minutes?
            </span>} data-id="element-253" data-mp="3vozxcde55rrz" />

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-pretty text-[15px] leading-relaxed text-navy-700 sm:text-lg" data-id="element-255" data-mp="3qpwt2v5zjpl2">
          <p className="font-bold text-navy-900" data-id="element-256" data-mp="1k10e7iecrr2v">Because the real problem isn’t diabetes.</p>
          <p data-id="element-257" data-mp="1oy0j3pzgunse">
            The real problem is that every patient arrives with a different combination of
            comorbidities, previous treatments, and risk factors, forcing you to make important
            clinical decisions under pressure and with limited time.
          </p>
        </div>

        <h3 className="mt-10 text-center text-[11px] font-black uppercase tracking-[0.16em] text-alert-600 sm:text-xs" data-id="element-258" data-mp="1wf3d2fy2un15">
          And then questions like these appear:
        </h3>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-259" data-mp="14ogql40z4rk3">
          {clinicalQuestions.map(question => <li key={question} className="flex items-start gap-3 rounded-2xl border border-navy-100 bg-navy-50/60 p-4" data-id="element-260" data-mp="zqnmcgj8e7mg">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert-500" aria-hidden="true" data-id="element-261" data-mp="1dnal8ouqv7v0" />
              <span className="text-[14px] font-semibold leading-snug text-navy-800 sm:text-[15px]" data-id="element-262" data-mp="2p3si2q297ci6">
                {question}
              </span>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-navy-900 p-5 sm:p-8" data-id="element-263" data-mp="1ht45ht9afc3n">
          <p className="text-balance text-center text-base font-bold text-white sm:text-lg" data-id="element-264" data-mp="1mre3ebmecqsy">
            And when that happens, many physicians end up doing the same thing.
          </p>
          <ol className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-265" data-mp="1qr6eow36db20">
            {timeWasters.map((item, i) => <li key={item} className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-266" data-mp="1vpq270xf2uwh" data-mpi={i}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-alert-500 text-xs font-black text-white" data-id="element-267" data-mp="133y7g8m6rrxc">
                  {i + 1}
                </span>
                <span className="text-sm font-semibold text-navy-100" data-id="element-268" data-mp="1ctzvx1igbccs">{item}</span>
              </li>)}
          </ol>
          <p className="mt-5 text-center text-sm font-semibold text-navy-200 sm:text-base" data-id="element-269" data-mp="fbrg5nvbib4s">
            And all while the patient is waiting for an answer.
          </p>
        </div>

        <CtaBlock kicker="Stop solving every consultation from scratch. Start making decisions with a system." label="👉 I want to make decisions without doubt" data-id="element-270" data-mp="csmrjwur5tbr" />
      </div>
    </section>;
}